import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router'
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateStateMutation } from "../../redux/services/stateService/state.Services";
import { FaMapMarkedAlt, FaPlus,FaArrowLeft } from "react-icons/fa";
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
function Addstate() {

    const navigate = useNavigate();
    const [createState, { isLoading }] = useCreateStateMutation();
    const [formData, setFormData] = useState({
        name: "",
        status: "active",
    });


    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    // SUBMIT
    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const response = await createState(formData).unwrap();

            console.log(response);

            successToast("success", "State Created Successfully");



            navigate(-1);

        } catch (error) {

            console.log(error);

            errorToast("error", "Failed To Create State");

        }
    };

    return (

        <div>

            {/* HEADER */}
            {/* <div className="page-header-breadcrumb all_breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            Add States
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li className="breadcrumb-item">
                                Add States
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate(-1)}
                    >

                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>

                        State List

                    </button>

                </div>

            </div> */}
<CommonBreadcrumb
    title="Add States"
    titleIcon={<FaMapMarkedAlt className="me-2 text-success" />}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "Add States" },
    ]}
    buttons={[
        {
            text: "State List",
            icon: <FaArrowLeft className="me-1" />,
            onClick: () => navigate(-1),
            className: "btn btn-primary",
        },
    ]}
/>
            {/* FORM */}
            <div className="card">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="container">

                            <div className="row align-items-end">

                                {/* INPUT */}
                                <div className="col-md-6">

                                    <div className="form-group">

                                        <label>
                                            Enter State
                                        </label>

                                        <input
                                            type="text"
                                            className='form-control custumform'
                                            placeholder='Enter State Name'
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />

                                    </div>
                                    <div className="form-group mt-3">

                                        <label>Status</label>

                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >

                                            <option value="active">
                                                Active
                                            </option>

                                            <option value="inactive">
                                                Inactive
                                            </option>

                                        </select>

                                    </div>

                                </div>

                                {/* BUTTON */}
                                <div className="col-md-6">

                                    <div className="form-group">

                                        <div className="button_submit">

                                            <button
                                                type="submit"
                                                className='btn btn-primary'
                                            >

                                                {
                                                    isLoading
                                                        ? "Loading..."
                                                        : "Submit"
                                                }

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

        </div>
    )
}

export default Addstate